import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

const Contacts = () => {
  const [state, handleSubmit] = useForm("manqbzgj"); // Replace with your actual Formspree endpoint

  return (
    <section className="contact-area contact-bg" style={{ backgroundImage: 'url("img/bg/contact_bg.jpg")' }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-lg-7">
            <div className="contact-form-wrap">
              <div className="widget-title mb-50">
                <h5 className="title">Contact Form</h5>
              </div>
              <div className="contact-form">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <input type="text" name="name" placeholder="Your Name *" required />
                    </div>
                    <div className="col-md-6">
                      <input type="email" name="email" placeholder="Your Email *" required />
                      <ValidationError prefix="Email" field="email" errors={state.errors} />
                    </div>
                  </div>
                  <input type="text" name="subject" placeholder="Subject *" required />
                  <textarea name="message" placeholder="Type Your Message..." required />
                  <ValidationError prefix="Message" field="message" errors={state.errors} />
                  <button className="btn" type="submit" disabled={state.submitting}>
                    {state.submitting ? 'Sending...' : 'Send Message'}
                  </button>
                  {state.succeeded && <p>Thank you! Your message has been sent.</p>}
                </form>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-5">
            <div className="widget-title mb-50">
              <h5 className="title">Information</h5>
            </div>
            <div className="contact-info-wrap">
              <p> Ready to start your next creative project? Whether you're looking to produce a film, web series, documentary, or commercial, <span>Satrang Media & Production</span> is here to help bring your ideas to the screen. Contact us today to discuss how we can make your vision a reality.</p>
              <div className="contact-info-list">
                <ul>
                  <li>
                    <div className="icon"><i className="fas fa-map-marker-alt" /></div>
                    <p><span>Follow :</span> @satrangmediaproductions</p>
                  </li>
                  <li>
                    <div className="icon"><i className="fas fa-phone-alt" /></div>
                    <p><span>Phone :</span>  +1 (647) 313-2403</p>
                  </li>
                  <li>
                    <div className="icon"><i className="fas fa-envelope" /></div>
                    <p><span>Email :</span> info@satrangmp.com</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
